import { useLocation, NavLink, Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Collapse } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { menuIcons } from "@constants/menu-icon.constants";
import logo from "@assets/images/logo/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { APP_NAME } from "@constants/app.constants";

function SideMenuTemplateComponent({
  templateModal: { theme, expandDrawer, menuList, moduleList, menuCollapsed },
  templateEvents: {
    handleShowDrawer,
    handleHideDrawer,
    handleOpenSubMenu,
    currentActiveGroup,
    setMenuVisibility,
  },
}) {
  const { pathname } = useLocation();

  const pathnameArray = pathname.split("/");

  const formattedPathName = "/" + pathnameArray[1] + "/" + pathnameArray[2];

  // console.log({ pathname, pathnameArray, formattedPathName, menuList });

  return (
    <div
      onMouseEnter={menuCollapsed ? () => handleShowDrawer() : null}
      onMouseLeave={menuCollapsed ? () => handleHideDrawer() : null}
      className={`main-menu menu-fixed menu-accordion menu-shadow ${
        theme === "dark" ? "menu-dark" : "menu-light"
      }  ${expandDrawer ? "expanded" : ""}`}
      data-scroll-to-active="true"
    >
      <div className="navbar-header">
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item me-auto">
            <NavLink to="/" className="navbar-brand">
              <span className="brand-logo">
                <img src={logo} alt="logo" />
              </span>
              <h2 className="brand-text mb-0">{APP_NAME}</h2>
            </NavLink>
          </li>
          <li className="nav-item nav-toggle">
            <div className="nav-link modern-nav-toggle cursor-pointer">
              <FeatherIcon
                icon={"x"}
                onClick={() => setMenuVisibility(false)}
                className="toggle-icon icon-x d-block d-xl-none"
                size={20}
              />
            </div>
          </li>
        </ul>
      </div>
      <div className="shadow-bottom"></div>
      <PerfectScrollbar
        className="main-menu-content"
        options={{ wheelPropagation: false }}
      >
        {moduleList &&
          moduleList.length > 0 &&
          moduleList.map((module, moduleIndex) => (
            <ul className="navigation navigation-main" key={moduleIndex}>
              <li className="navigation-header mt-1">
                <span>{module.name}</span>
              </li>

              {module.menus &&
                module.menus.length > 0 &&
                module.menus.map((menu, index) => (
                  <>
                    {menu.sub_menus.length === 0 ? (
                      <li
                        className={`nav-item ${
                          pathname === `/${menu.menu_url}` ? "active" : ""
                        }`}
                        key={menu.menu_id}
                      >
                        <Link
                          className="d-flex align-items-center"
                          to={`/${menu.menu_url}`}
                        >
                          <FontAwesomeIcon
                            icon={menu.menu_icon}
                            style={{ width: "18px", height: "18px" }}
                          />
                          <span className="menu-item text-truncate">
                            {menu.menu_name}
                          </span>
                        </Link>
                      </li>
                    ) : (
                      <li
                        className={`nav-item has-sub ${
                          menu.subMenuOpen ||
                          currentActiveGroup(menu, formattedPathName)
                            ? "open menu-collapsed-open sidebar-group-active"
                            : ""
                        }`}
                      >
                        <a
                          onClick={() =>
                            handleOpenSubMenu(moduleIndex, index, menu)
                          }
                          className="d-flex align-items-center"
                        >
                          <FontAwesomeIcon
                            icon={menu.menu_icon}
                            style={{ width: "18px", height: "18px" }}
                          />
                          <span className="menu-title text-truncate">
                            {menu.menu_name}
                          </span>
                        </a>
                        <ul className="menu-content">
                          <Collapse
                            key={menu.menu_id}
                            isOpen={
                              menu.subMenuOpen ||
                              currentActiveGroup(menu, formattedPathName)
                            }
                          >
                            {menu.sub_menus &&
                              menu.sub_menus.length > 0 &&
                              menu.sub_menus.map((subMenu) => (
                                <li
                                  className={`nav-item ${
                                    formattedPathName === `/${subMenu.menu_url}`
                                      ? "active"
                                      : ""
                                  }`}
                                  key={subMenu.menu_url}
                                >
                                  <Link
                                    className="align-items-center"
                                    to={`/${subMenu.menu_url}`}
                                  >
                                    <FontAwesomeIcon
                                      icon={subMenu.menu_icon}
                                      style={{ width: "18px", height: "18px" }}
                                    />
                                    <span className="menu-item text-truncate">
                                      {subMenu.menu_name}
                                    </span>
                                  </Link>
                                </li>
                              ))}
                          </Collapse>
                        </ul>
                      </li>
                    )}
                  </>
                ))}
            </ul>
          ))}
      </PerfectScrollbar>
    </div>
  );
}

export default SideMenuTemplateComponent;
